export const FLIGHT_FREEZE_HEADER = "Price Freeze";
export const FLIGHT_FREEZE_CONTINUE_BUTTON_TEXT = "Continue";
export const FLIGHT_FREEZE_COMPLETE_BUTTON_TEXT = (
  useLockPriceLanguage?: boolean
) => `${useLockPriceLanguage ? "Lock" : "Freeze"} this price`;
export const REVIEW_ITINERARY_TITLE = "Review itinerary";
export const CONTACT_INFORMATION = "Contact information:";
export const REVIEW_MY_FROZEN_PRICE_TEXT = "Review my frozen price";
